import { useTranslation } from "react-i18next";
import { FiFile } from "react-icons/fi";
import { ViewDocumentAsOwnerDto } from "../../../autogen/bff-api";
import { DocumentsAsOwnerTable } from "../../../common/documents/DocumentsAsOwnerTable";
import { SectionCard } from "../../sourcing-events/portal/view-single/SectionCard";

export const DocumentsSection = ({ documents }: { documents: ViewDocumentAsOwnerDto[] }) => {
  const { t } = useTranslation();
  return (
    <SectionCard icon={FiFile} title={t("Documents")} count={documents.length}>
      <DocumentsAsOwnerTable documents={documents} />
    </SectionCard>
  );
};
